import { render, staticRenderFns } from "./DocumentsView.vue?vue&type=template&id=1b08ebed&scoped=true"
import script from "./DocumentsView.vue?vue&type=script&lang=ts"
export * from "./DocumentsView.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsView.vue?vue&type=style&index=0&id=1b08ebed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b08ebed",
  null
  
)

export default component.exports